var exports = {
  "u": "xe564cbfb--625d77--crumb",
};

module.exports = exports;
